import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {TaskSchemaNodeSection, TaskSchemaNodeSectionType} from './processFlowchartConfigEditorConstants';
import {
  isStaticTaskSchemaNodeData,
  StaticFlowchartNodeData,
  TaskSchemaDomainData,
  TaskSchemaNodeRowData,
} from './processFlowchartConfigEditorNodeTypes';

export function convertRootRowToMapFromStartRow(rootRow: TaskSchemaNodeRowData): TaskSchemaNodeRowData {
  return {
    ...rootRow,
    isFlowchartTask: true,
    sectionName: TaskSchemaNodeSection.MAP_FROM_START,
    sectionType: TaskSchemaNodeSectionType.MAP_FROM_START,
  };
}

export function filterToAddableMapFromStartRows(
  candidateRows: Array<TaskSchemaNodeRowData>,
  existingMapFromStartRows: Array<TaskSchemaNodeRowData>
): Array<TaskSchemaNodeRowData> {
  const existingMapFromStartRowIds = existingMapFromStartRows.map((row) => row.clientId);
  return candidateRows.filter((row) => !existingMapFromStartRowIds.includes(row.clientId));
}

/**
 * Populates the map from start section rows on nodes using root inputs rows.
 * Updates are done in place
 */
export function populateMapFromStartSectionRows(
  nodesStaticData: Array<StaticFlowchartNodeData>,
  rootNodeData: TaskSchemaDomainData,
  mapFromStartFieldIdsByNode: Record<string, Array<string>>
): void {
  const rootNodeSection = rootNodeData.sections.find(
    (section) => section.sectionType === TaskSchemaNodeSectionType.INPUTS
  );
  if (!rootNodeSection) {
    const hasAnyMappings = Object.values(mapFromStartFieldIdsByNode).some((ids) => ids.length > 0);
    if (hasAnyMappings) {
      throw new Error('Map from start mappings exist but root node has no INPUTS section');
    }
    return;
  }
  for (const node of nodesStaticData) {
    if (
      !isStaticTaskSchemaNodeData(node) ||
      node.nodeDetailsType === ProcessFlowchartNodeDetailsType.OUTPUT_NODE_DETAILS ||
      node.nodeDetailsType === ProcessFlowchartNodeDetailsType.ROOT_NODE_DETAILS
    ) {
      continue;
    }

    const mapFromStartSection = node.sections.find(
      (section) => section.sectionType === TaskSchemaNodeSectionType.MAP_FROM_START
    );

    if (!mapFromStartSection) {
      throw new Error('MAP_FROM_START section should exist (created by adapter)');
    }

    const sectionRows: Array<TaskSchemaNodeRowData> = [];
    const mapFromStartFieldIds = mapFromStartFieldIdsByNode[node.id];
    if (mapFromStartFieldIds) {
      for (const fieldId of mapFromStartFieldIds) {
        const rootNodeFieldRow = rootNodeSection.sectionRows.find((row) => row.clientId === fieldId);
        if (!rootNodeFieldRow) {
          throw new Error('Map from start field not found on root node');
        }
        sectionRows.push(convertRootRowToMapFromStartRow(rootNodeFieldRow));
      }
    }

    mapFromStartSection.sectionRows = sectionRows;
  }
}
